'use strict';

var BiLoggerClientFactory = require('./bi-logger-factory');
var BiLogger = require('./bi-logger');
var biLoggerManager = require('./bi-logger-manager');

module.exports.BiLoggerFactory = BiLoggerClientFactory;
module.exports.BiLogger = BiLogger;
module.exports.BiLoggerManager = biLoggerManager.BiLoggerManager;

module.exports.factory = function () {
  return new BiLoggerClientFactory();
};
module.exports.manager = biLoggerManager.manager;
//# sourceMappingURL=index.js.map